import React, { useState } from 'react';
import axios from 'axios';

const AuthorRegistrationEdit = () => {
  const API = process.env.REACT_APP_API_BASE_URL;
  const [formData, setFormData] = useState({
    UserName: '',
    AuthorName: '',
    Address: '',
    EmailID: '',
    ContactNumber: '',
    WillingnessFile: '' // added to hold previous file name
  });
  const [password, setPassword] = useState('');
  const [oldUserName, setOldUserName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null); // new state to track file

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = { UserName: oldUserName, Password: password };

    try {
      const res = await axios.post(`${API}/api/author/get-author`, data);
      // console.log(res.data);

      // Assuming res.data contains the form data
      setFormData({
        UserName: res.data.UserName,
        AuthorName: res.data.AuthorName,
        Address: res.data.Address,
        EmailID: res.data.EmailID,
        ContactNumber: res.data.ContactNumber,
        WillingnessFile: res.data.WillingnessFile || '' // store existing file if available
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("UserName", formData.UserName);
    form.append("AuthorName", formData.AuthorName);
    form.append("Address", formData.Address);
    form.append("EmailID", formData.EmailID);
    form.append("ContactNumber", formData.ContactNumber);
    form.append("OldUserName", oldUserName);
    form.append("PreviousWillingnessFile", formData.WillingnessFile || '');

    if (selectedFile) {
      form.append("WillingnessFile", selectedFile);
    }

    try {
      const res = await axios.post(`${API}/api/author/update-author`, form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      alert(res.data.message);
      setFormData({
        UserName: '',
        AuthorName: '',
        Address: '',
        EmailID: '',
        ContactNumber: '',
        WillingnessFile: ''
      });
      setSelectedFile(null);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="container mt-5 mb-5 d-flex justify-content-center">
      <div className="card p-4 shadow-sm w-100" style={{ maxWidth: '600px' }}>
        <h3 className="text-center page-title mb-4">Enter Author Credentials</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="oldUserName" className="form-label fw-semibold">
              User Name
            </label>
            <input
              type="text"
              name="oldUserName"
              id="oldUserName"
              className="form-control"
              onChange={(e) => { setOldUserName(e.target.value) }}
              required
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="Password" className="form-label fw-semibold">
              Password
            </label>
            <input
              type="password"
              name="password"
              id="Password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100 mt-2">
            Get Data
          </button>
        </form>

        {/* Secound form */}
        <h3 className="text-center page-title mb-4 mt-4">Edit Author Credentials</h3>
        <form onSubmit={handleEdit} encType="multipart/form-data">
          <div className="row">
            {/* UserName */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">User Name</label>
              <input
                type="text"
                name="UserName"
                className="form-control"
                value={formData.UserName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Author Name */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">Author Name</label>
              <input
                type="text"
                name="AuthorName"
                className="form-control"
                value={formData.AuthorName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Address */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">Address</label>
              <textarea
                name="Address"
                className="form-control"
                value={formData.Address}
                rows={3}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Email */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">Email</label>
              <input
                type="email"
                name="EmailID"
                className="form-control"
                value={formData.EmailID}
                onChange={handleChange}
                required
              />
            </div>

            {/* Contact Number */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">Contact Number</label>
              <input
                type="text"
                name="ContactNumber"
                className="form-control"
                value={formData.ContactNumber}
                onChange={handleChange}
              />
            </div>

            {/* Willingness File Upload */}
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">Upload Willingness File</label>
              <input
                type="file"
                className="form-control"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
              {formData.WillingnessFile && !selectedFile && (
                <small className="text-muted">
                  Current file: {formData.WillingnessFile}
                </small>
              )}
            </div>

            {/* Submit button */}
            <button type="submit" className="btn btn-primary w-100">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthorRegistrationEdit;
